export default "__VITE_ASSET__1bea6ebd__"